import http from './http';

const ENDPOINTS = {
  // Visit endpoints
  VISITS: '/api/v1/visits',
  VISIT_BY_ID: (id) => `/api/v1/visits/${id}`,
  VISIT_STATS: '/api/v1/visits/stats',
  PATIENT_VISIT_HISTORY: (patientId) => `/api/v1/visits/patient/${patientId}`,
  TEST: '/api/v1/visits/test',
};

/**
 * Visit Management API Service
 */
export const visitAPI = {
  /**
   * Test endpoint
   */
  test: async () => {
    const response = await http.get(ENDPOINTS.TEST);
    return response.data;
  },

  /**
   * Get visit statistics
   */
  getStats: async (params = {}) => {
    const response = await http.get(ENDPOINTS.VISIT_STATS, { params });
    return response.data;
  },

  /**
   * Create a new visit/checkup
   */
  createVisit: async (visitData) => {
    const response = await http.post(ENDPOINTS.VISITS, visitData);
    return response.data;
  },

  /**
   * Get all visits with filtering and pagination
   */
  listVisits: async (params = {}) => {
    const response = await http.get(ENDPOINTS.VISITS, { params });
    return response.data;
  },

  /**
   * Get visit by ID
   */
  getVisitById: async (id) => {
    const response = await http.get(ENDPOINTS.VISIT_BY_ID(id));
    return response.data;
  },

  /**
   * Update visit information
   */
  updateVisit: async (id, updateData) => {
    const response = await http.patch(ENDPOINTS.VISIT_BY_ID(id), updateData);
    return response.data;
  },

  /**
   * Get patient's visit history
   */
  getPatientVisitHistory: async (patientId, params = {}) => {
    const response = await http.get(ENDPOINTS.PATIENT_VISIT_HISTORY(patientId), { params });
    return response.data;
  }
};

export default visitAPI;